import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1521.46133,53 C1417.99467,53 1321.99467,95.6666667 1254.79467,166.066667 C1217.46133,203.4 1188.66133,249.266667 1170.528,300.466667 C1155.59467,338.866667 1148.128,381.533333 1148.128,426.333333 C1148.128,445.64 1150.15467,464.733333 1153.46133,483.72 C1156.23467,501.64 1160.71467,519.026667 1165.83467,536.306667 L1165.83467,536.413333 C1167.648,542.386667 1168.50133,548.573333 1170.528,554.333333 C1173.728,562.866667 1177.99467,572.466667 1180.128,575.666667 C1181.19467,578.866667 1183.328,583.133333 1185.46133,586.333333 C1204.66133,630.066667 1232.39467,668.466667 1270.79467,701.533333 C1272.288,702.813333 1284.23467,711.666667 1302.15467,723.293333 C1296.39467,753.48 1284.55467,782.813333 1261.30133,806.173333 C1198.79467,868.573333 1097.46133,868.573333 1034.95467,806.173333 C972.554667,743.666667 972.554667,642.333333 1034.95467,579.826667 C1043.38133,571.506667 1053.728,567.133333 1063.328,561.053333 C1050.31467,518.813333 1041.46133,472.733333 1041.46133,426.333333 C1041.46133,370.333333 1050.95467,316.36 1070.15467,266.333333 L745.141333,266.333333 L-0.032,1011.4 L829.728,1841.16 L1574.79467,1095.98667 L1574.79467,426.333333 C1574.79467,338.12 1503.008,266.333333 1414.79467,266.333333 L1308.23467,266.333333 C1357.19467,200.733333 1435.91467,159.666667 1521.46133,159.666667 C1668.66133,159.666667 1788.128,279.133333 1788.128,426.333333 L1894.79467,426.333333 C1894.79467,220.466667 1727.328,53 1521.46133,53",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTagSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTagSolid, _Component);

  var _super = _createSuper(IconTagSolid);

  function IconTagSolid() {
    _classCallCheck(this, IconTagSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTagSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTag",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTagSolid.displayName = "IconTagSolid";
  return IconTagSolid;
}(Component);

IconTagSolid.glyphName = 'tag';
IconTagSolid.variant = 'Solid';
IconTagSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTagSolid;
export { IconTagSolid };